import { render } from "./projectCard.vue?vue&type=template&id=19bea531"
import script from "./projectCard.vue?vue&type=script&lang=js"
export * from "./projectCard.vue?vue&type=script&lang=js"

import "./projectCard.vue?vue&type=style&index=0&id=19bea531&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__